var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ownArchives"},[_c('common-title',{attrs:{"titleName":"我的档案","isAPPShow":true}},[_c('div',{attrs:{"slot":"btnSty"},slot:"btnSty"},[_c('div',{staticClass:"hrefBtn",on:{"click":_vm.modify}},[_vm._v("修改档案")])])]),_c('ArchivesInfo',{attrs:{"info":_vm.archivesInfo}}),_c('Loading',{ref:"loading"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }